module.exports = __webpack_public_path__ + "media/icons/insta-d39397c0.png";